export const NotificationType = {
    0: "SUCCESS",
    1: "ERROR",
    3: "WARNING",
    4: "INFO"
}